import React, { createContext, useContext, useEffect, useState } from "react";
import SocialService from "services/Admin/SocialService";
import SettingsService from "services/Admin/SettingsService";

const SiteContext = createContext({ social: {}, settings: {}, settingsLoaded: false });

export const SiteProvider = ({ children }) => {
	const [social, setSocial] = useState({});
	const [settings, setSettings] = useState({});
	const [settingsLoaded, setSettingsLoaded] = useState(false);

	useEffect(() => {
		new SocialService()
			.getList()
			.then((res) => {
				if (res?.data) setSocial(res?.data?.data);
			})
			.catch(() => {});

		new SettingsService()
			.getList()
			.then((res) => {
				const d = res?.data?.data ?? res?.data ?? {};
				setSettings(d);
			})
			.catch(() => {})
			.finally(() => setSettingsLoaded(true));
	}, []);

	return (
		<SiteContext.Provider value={{ social, settings, settingsLoaded }}>
			{children}
		</SiteContext.Provider>
	);
};

export const useSite = () => useContext(SiteContext);
